import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormControl, Validators } from '@angular/forms'
import { Store } from '@ngrx/store'
import { AmplitudeService } from '@tv3/services/amplitude.service'
import {
  ConfirmDialogService,
  distinctObjectUntilChangedByFields,
  isSomething,
  untilDestroy,
} from '@tokeet-frontend/tv3-platform'
import { TemplateService } from '@tokeet-frontend/templates'
import { AuthService } from '@tv3/services/auth.service'
import { NotifyAutomationBaseComponent } from '../notify-automatotion.component'
import { Actions } from '@ngrx/effects'

@Component({
  selector: 'app-notify-users-automation',
  templateUrl: './notify-users-automation.component.html',
  styleUrls: ['./notify-users-automation.component.scss'],
})
export class NotifyUsersAutomationComponent extends NotifyAutomationBaseComponent implements OnInit {
  constructor(
    private auth: AuthService,
    protected actions: Actions,
    protected store: Store<any>,
    protected amplitudeService: AmplitudeService,
    protected templateService: TemplateService,
    protected confirm: ConfirmDialogService
  ) {
    super(actions, store, amplitudeService, templateService, confirm)
    this.form.addControl('users', new FormControl([this.auth.user?.id], [Validators.required]))
  }

  ngOnInit(): void {
    super.ngOnInit()

    this.automation$.pipe(distinctObjectUntilChangedByFields(['users']), untilDestroy(this)).subscribe((item) => {
      this.form.patchValue(
        {
          users: isSomething(item?.users) ? item?.users : [this.auth.user?.id],
        },
        { emitEvent: false }
      )
    })
  }

  getAutopilotId() {
    return `autopilot-notify-users|${this.service}|${this.type}|${this.event}|${this.handler}|${this.idSuffix || ''}`
  }
}
